import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { fromEvent } from 'rxjs';
import { debounceTime, map, pairwise } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  public scrollingDown$: Observable<boolean> =
    typeof window !== 'undefined'
      ? fromEvent(window, 'scroll').pipe(
          map(_ => window.scrollY),
          pairwise(),
          debounceTime(10),
          map(([a, b]) => !(a - b > 0)),
        )
      : of(false);
}
